__webpack_require__.p = "https://certificate.quantstamp.com/full/migration-core-venus/dd8918f3-6f1e-4746-8fd8-ca13ecb55b0d/";